/*
These are the reducers for the page.
Think of these as the "event handlers" for the page.
They process business logic and update the state within the page's store
*/
import {
  DynamicSelectActionType,
  DynamicSelectInitAction,
  DynamicSelectFailureAction,
  DynamicSelectSuccessAction,
  DynamicSelectClearOptionsAction
} from '@common/components/dynamic-select/dynamic-select.actions';
import { OptionsViewModel } from '@models/common.models';
import { createReducer } from '@common/redux-utils';
import { DynamicSelectIdentifier } from '@common/components/dynamic-select/dynamic-select-types';

export interface DynamicSelectState {
  errors: { [property: string]: string };
  options: { [property: string]: OptionsViewModel[] };
  loadingOptions: DynamicSelectIdentifier[];
}

// This is the initial state of the page
const initialState: DynamicSelectState = {
  errors: {},
  options: {},
  loadingOptions: []
};

function loadSelectOptionsInit(state: DynamicSelectState, action: DynamicSelectInitAction): DynamicSelectState {
  state.loadingOptions.push(action.identifier);
  const newErrors = {
    // clear out an error associated with this identifier before reloading
    ...state.errors,
    [action.identifier]: ''
  };

  return {
    ...state,
    loadingOptions: state.loadingOptions,
    errors: newErrors
  };
}

function loadSelectOptionsFail(state: DynamicSelectState, action: DynamicSelectFailureAction): DynamicSelectState {
  const newErrors = {
    ...state.errors,
    [action.identifier]: action.errorMessage
  };
  return {
    ...state,
    errors: newErrors,
    loadingOptions: state.loadingOptions.filter(x => x !== action.identifier) // return all options not equal to the one in the fail action, removing it from the list
  };
}

function loadSelectOptionsSuccess(state: DynamicSelectState, action: DynamicSelectSuccessAction): DynamicSelectState {
  const newOptions = {
    ...state.options,
    [action.identifier]: action.options
  };

  return {
    ...state,
    options: newOptions,
    loadingOptions: state.loadingOptions.filter(x => x !== action.identifier)
  };
}

function clearOptions(state: DynamicSelectState, action: DynamicSelectClearOptionsAction): DynamicSelectState {
  return {
    errors: {},
    options: {},
    loadingOptions: []
  };
}

// This creates the reducer as redux wants it w/ a helper function
// There should an entry for each action type
export const DynamicSelectReducer = createReducer(initialState, {
  [DynamicSelectActionType.LoadOptionsInit]: loadSelectOptionsInit,
  [DynamicSelectActionType.LoadOptionsSuccess]: loadSelectOptionsSuccess,
  [DynamicSelectActionType.LoadOptionsFail]: loadSelectOptionsFail,
  [DynamicSelectActionType.ClearOptions]: clearOptions
});



// WEBPACK FOOTER //
// ./src/common/components/dynamic-select/dynamic-select.reducer.tsx